<div class="webview-frame">
  <!-- Close button -->
  <button 
    type="button"
    class="action-close" 
    (click)="closeIframe()"
    aria-label="Cerrar vista web">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>

  <!-- Loading state -->
  @if (isLoading()) {
    <div class="loading-overlay" role="status" aria-live="polite">
      <div class="spinner"></div>
      <p>Cargando contenido...</p>
    </div>
  }

  <!-- Error state -->
  @if (hasError()) {
    <div class="error-overlay" role="alert">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <h3>Error al cargar el contenido</h3>
      <p>No se pudo cargar la página solicitada.</p>
      <button type="button" (click)="closeIframe()" class="btn-close-error">
        Cerrar
      </button>
    </div>
  }

  <!-- Iframe content -->
  @if (isReady()) {
    <iframe 
      [src]="iframeSrc()"
      (load)="onIframeLoad()"
      (error)="onIframeError()"
      title="Vista web"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      loading="lazy">
    </iframe>
  }
</div>